// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___1hJuV","sa":"sa___1-vmR","flex":"flex___2MBEV"};